
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models.js'
export type * from './prismaNamespace.js'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  Asset: 'Asset',
  AssetUpload: 'AssetUpload',
  Pole: 'Pole',
  Manhole: 'Manhole',
  TerminalBox: 'TerminalBox',
  Handhole: 'Handhole',
  Riser: 'Riser',
  Vault: 'Vault',
  PullBox: 'PullBox',
  Pedestal: 'Pedestal',
  SpliceClosure: 'SpliceClosure',
  UndergroundRoute: 'UndergroundRoute',
  OverheadRoute: 'OverheadRoute',
  Conduit: 'Conduit',
  FiberCable: 'FiberCable',
  Crew: 'Crew',
  CustomFieldDefinition: 'CustomFieldDefinition',
  FieldCorrection: 'FieldCorrection',
  LayerDefinition: 'LayerDefinition',
  FieldNote: 'FieldNote',
  ServiceArea: 'ServiceArea',
  Premise: 'Premise',
  Location: 'Location',
  LocationHistory: 'LocationHistory',
  Notification: 'Notification',
  Organization: 'Organization',
  Project: 'Project',
  ProjectType: 'ProjectType',
  CrewMembership: 'CrewMembership',
  TicketAssignment: 'TicketAssignment',
  TicketAssignee: 'TicketAssignee',
  CrewSkill: 'CrewSkill',
  TicketSkill: 'TicketSkill',
  ProjectAsset: 'ProjectAsset',
  ProjectPremise: 'ProjectPremise',
  ProjectTypeLayers: 'ProjectTypeLayers',
  Shift: 'Shift',
  Skill: 'Skill',
  Ticket: 'Ticket',
  AiReview: 'AiReview',
  TicketNote: 'TicketNote',
  TicketUpload: 'TicketUpload',
  User: 'User'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const AssetScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  sourceId: 'sourceId',
  name: 'name',
  assetType: 'assetType',
  structureNo: 'structureNo',
  owner: 'owner',
  acquireSource: 'acquireSource',
  depreciationLife: 'depreciationLife',
  acquireCost: 'acquireCost',
  assetStatus: 'assetStatus',
  age: 'age',
  createdUser: 'createdUser',
  lastEditedUser: 'lastEditedUser',
  inspectionDate: 'inspectionDate',
  customAttributes: 'customAttributes',
  lastUpdated: 'lastUpdated',
  sourceUploadId: 'sourceUploadId'
} as const

export type AssetScalarFieldEnum = (typeof AssetScalarFieldEnum)[keyof typeof AssetScalarFieldEnum]


export const AssetUploadScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  fileName: 'fileName',
  s3Url: 's3Url',
  status: 'status',
  uploadedAt: 'uploadedAt'
} as const

export type AssetUploadScalarFieldEnum = (typeof AssetUploadScalarFieldEnum)[keyof typeof AssetUploadScalarFieldEnum]


export const PoleScalarFieldEnum = {
  organizationId: 'organizationId',
  length: 'length',
  diameter: 'diameter',
  mountingType: 'mountingType',
  materials: 'materials',
  owner: 'owner',
  laborCost: 'laborCost',
  installDate: 'installDate',
  assetId: 'assetId'
} as const

export type PoleScalarFieldEnum = (typeof PoleScalarFieldEnum)[keyof typeof PoleScalarFieldEnum]


export const ManholeScalarFieldEnum = {
  organizationId: 'organizationId',
  status: 'status',
  depth: 'depth',
  width: 'width',
  coverType: 'coverType',
  material: 'material',
  assetId: 'assetId'
} as const

export type ManholeScalarFieldEnum = (typeof ManholeScalarFieldEnum)[keyof typeof ManholeScalarFieldEnum]


export const TerminalBoxScalarFieldEnum = {
  organizationId: 'organizationId',
  status: 'status',
  depth: 'depth',
  width: 'width',
  coverType: 'coverType',
  material: 'material',
  assetId: 'assetId'
} as const

export type TerminalBoxScalarFieldEnum = (typeof TerminalBoxScalarFieldEnum)[keyof typeof TerminalBoxScalarFieldEnum]


export const HandholeScalarFieldEnum = {
  organizationId: 'organizationId',
  status: 'status',
  depth: 'depth',
  width: 'width',
  coverType: 'coverType',
  material: 'material',
  assetId: 'assetId'
} as const

export type HandholeScalarFieldEnum = (typeof HandholeScalarFieldEnum)[keyof typeof HandholeScalarFieldEnum]


export const RiserScalarFieldEnum = {
  organizationId: 'organizationId',
  comments: 'comments',
  assetId: 'assetId'
} as const

export type RiserScalarFieldEnum = (typeof RiserScalarFieldEnum)[keyof typeof RiserScalarFieldEnum]


export const VaultScalarFieldEnum = {
  organizationId: 'organizationId',
  vaultType: 'vaultType',
  material: 'material',
  depth: 'depth',
  width: 'width',
  length: 'length',
  cableEntryPoints: 'cableEntryPoints',
  assetId: 'assetId'
} as const

export type VaultScalarFieldEnum = (typeof VaultScalarFieldEnum)[keyof typeof VaultScalarFieldEnum]


export const PullBoxScalarFieldEnum = {
  organizationId: 'organizationId',
  status: 'status',
  depth: 'depth',
  width: 'width',
  coverType: 'coverType',
  material: 'material',
  hasDrains: 'hasDrains',
  groundingPresent: 'groundingPresent',
  mountingHardware: 'mountingHardware',
  assetId: 'assetId'
} as const

export type PullBoxScalarFieldEnum = (typeof PullBoxScalarFieldEnum)[keyof typeof PullBoxScalarFieldEnum]


export const PedestalScalarFieldEnum = {
  organizationId: 'organizationId',
  pedestalType: 'pedestalType',
  material: 'material',
  height: 'height',
  width: 'width',
  depth: 'depth',
  spliceCapacity: 'spliceCapacity',
  portCount: 'portCount',
  cableEntryType: 'cableEntryType',
  terminationType: 'terminationType',
  cableTypesSupported: 'cableTypesSupported',
  isPowered: 'isPowered',
  isLockable: 'isLockable',
  isGrounded: 'isGrounded',
  sealType: 'sealType',
  weatherRating: 'weatherRating',
  assetId: 'assetId'
} as const

export type PedestalScalarFieldEnum = (typeof PedestalScalarFieldEnum)[keyof typeof PedestalScalarFieldEnum]


export const SpliceClosureScalarFieldEnum = {
  organizationId: 'organizationId',
  closureType: 'closureType',
  fiberCapacity: 'fiberCapacity',
  spliceTrayCount: 'spliceTrayCount',
  weatherRating: 'weatherRating',
  assetId: 'assetId'
} as const

export type SpliceClosureScalarFieldEnum = (typeof SpliceClosureScalarFieldEnum)[keyof typeof SpliceClosureScalarFieldEnum]


export const UndergroundRouteScalarFieldEnum = {
  organizationId: 'organizationId',
  width: 'width',
  length: 'length',
  fillMaterial: 'fillMaterial',
  trenchMethod: 'trenchMethod',
  sharedTrench: 'sharedTrench',
  status: 'status',
  laborCost: 'laborCost',
  startEndLocation: 'startEndLocation',
  installDate: 'installDate',
  assetId: 'assetId'
} as const

export type UndergroundRouteScalarFieldEnum = (typeof UndergroundRouteScalarFieldEnum)[keyof typeof UndergroundRouteScalarFieldEnum]


export const OverheadRouteScalarFieldEnum = {
  organizationId: 'organizationId',
  mountingMethod: 'mountingMethod',
  sagClearance: 'sagClearance',
  spanCount: 'spanCount',
  installationDate: 'installationDate',
  assetId: 'assetId'
} as const

export type OverheadRouteScalarFieldEnum = (typeof OverheadRouteScalarFieldEnum)[keyof typeof OverheadRouteScalarFieldEnum]


export const ConduitScalarFieldEnum = {
  organizationId: 'organizationId',
  conduitType: 'conduitType',
  diameter: 'diameter',
  length: 'length',
  conduitCount: 'conduitCount',
  installationMethod: 'installationMethod',
  encasementType: 'encasementType',
  entryType: 'entryType',
  housing: 'housing',
  azLocation: 'azLocation',
  color: 'color',
  laborCost: 'laborCost',
  assetId: 'assetId'
} as const

export type ConduitScalarFieldEnum = (typeof ConduitScalarFieldEnum)[keyof typeof ConduitScalarFieldEnum]


export const FiberCableScalarFieldEnum = {
  organizationId: 'organizationId',
  fiberCount: 'fiberCount',
  availableFibers: 'availableFibers',
  modelName: 'modelName',
  cableType: 'cableType',
  installationType: 'installationType',
  bufferTubeType: 'bufferTubeType',
  cableDiameter: 'cableDiameter',
  lossDb: 'lossDb',
  status: 'status',
  glassType: 'glassType',
  armor: 'armor',
  startEndStructure: 'startEndStructure',
  startEndEquipment: 'startEndEquipment',
  assetId: 'assetId'
} as const

export type FiberCableScalarFieldEnum = (typeof FiberCableScalarFieldEnum)[keyof typeof FiberCableScalarFieldEnum]


export const CrewScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  name: 'name',
  operationalStatus: 'operationalStatus',
  currentLatitude: 'currentLatitude',
  currentLongitude: 'currentLongitude',
  locationUpdatedAt: 'locationUpdatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CrewScalarFieldEnum = (typeof CrewScalarFieldEnum)[keyof typeof CrewScalarFieldEnum]


export const CustomFieldDefinitionScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  entity: 'entity',
  fieldLabel: 'fieldLabel',
  fieldName: 'fieldName',
  fieldType: 'fieldType',
  fieldOptions: 'fieldOptions',
  isRequired: 'isRequired',
  description: 'description',
  isEditable: 'isEditable',
  isVisible: 'isVisible',
  projectTypeId: 'projectTypeId'
} as const

export type CustomFieldDefinitionScalarFieldEnum = (typeof CustomFieldDefinitionScalarFieldEnum)[keyof typeof CustomFieldDefinitionScalarFieldEnum]


export const FieldCorrectionScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  attributeChanges: 'attributeChanges',
  proposedGeom: 'proposedGeom',
  oldGeom: 'oldGeom',
  status: 'status',
  correctionType: 'correctionType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  resolvedAt: 'resolvedAt',
  assetId: 'assetId',
  ticketId: 'ticketId',
  submittedById: 'submittedById',
  reviewedById: 'reviewedById',
  reviewNotes: 'reviewNotes'
} as const

export type FieldCorrectionScalarFieldEnum = (typeof FieldCorrectionScalarFieldEnum)[keyof typeof FieldCorrectionScalarFieldEnum]


export const LayerDefinitionScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  key: 'key',
  sourceTable: 'sourceTable',
  sourceFilter: 'sourceFilter',
  displayName: 'displayName',
  geomType: 'geomType',
  category: 'category',
  layerType: 'layerType',
  schemaConfig: 'schemaConfig',
  styles: 'styles',
  zIndex: 'zIndex',
  opacity: 'opacity',
  isVisible: 'isVisible',
  minZoom: 'minZoom',
  maxZoom: 'maxZoom'
} as const

export type LayerDefinitionScalarFieldEnum = (typeof LayerDefinitionScalarFieldEnum)[keyof typeof LayerDefinitionScalarFieldEnum]


export const FieldNoteScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  content: 'content',
  isPublic: 'isPublic',
  createdAt: 'createdAt',
  createdById: 'createdById'
} as const

export type FieldNoteScalarFieldEnum = (typeof FieldNoteScalarFieldEnum)[keyof typeof FieldNoteScalarFieldEnum]


export const ServiceAreaScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  name: 'name',
  description: 'description'
} as const

export type ServiceAreaScalarFieldEnum = (typeof ServiceAreaScalarFieldEnum)[keyof typeof ServiceAreaScalarFieldEnum]


export const PremiseScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  sourceId: 'sourceId',
  streetName: 'streetName',
  city: 'city',
  state: 'state',
  zipcode: 'zipcode',
  type: 'type'
} as const

export type PremiseScalarFieldEnum = (typeof PremiseScalarFieldEnum)[keyof typeof PremiseScalarFieldEnum]


export const LocationScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  latitude: 'latitude',
  longitude: 'longitude',
  heading: 'heading',
  speed: 'speed',
  accuracy: 'accuracy',
  updatedAt: 'updatedAt',
  userId: 'userId'
} as const

export type LocationScalarFieldEnum = (typeof LocationScalarFieldEnum)[keyof typeof LocationScalarFieldEnum]


export const LocationHistoryScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  latitude: 'latitude',
  longitude: 'longitude',
  heading: 'heading',
  speed: 'speed',
  accuracy: 'accuracy',
  recordedAt: 'recordedAt',
  userId: 'userId'
} as const

export type LocationHistoryScalarFieldEnum = (typeof LocationHistoryScalarFieldEnum)[keyof typeof LocationHistoryScalarFieldEnum]


export const NotificationScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  message: 'message',
  title: 'title',
  isRead: 'isRead',
  link: 'link',
  createdAt: 'createdAt',
  userId: 'userId'
} as const

export type NotificationScalarFieldEnum = (typeof NotificationScalarFieldEnum)[keyof typeof NotificationScalarFieldEnum]


export const OrganizationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  domain: 'domain',
  timezone: 'timezone',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  state: 'state',
  country: 'country',
  zipcode: 'zipcode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OrganizationScalarFieldEnum = (typeof OrganizationScalarFieldEnum)[keyof typeof OrganizationScalarFieldEnum]


export const ProjectScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  projectNumber: 'projectNumber',
  name: 'name',
  status: 'status',
  description: 'description',
  startDate: 'startDate',
  endDate: 'endDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  projectTypeId: 'projectTypeId',
  serviceAreaId: 'serviceAreaId'
} as const

export type ProjectScalarFieldEnum = (typeof ProjectScalarFieldEnum)[keyof typeof ProjectScalarFieldEnum]


export const ProjectTypeScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  name: 'name',
  slug: 'slug',
  description: 'description'
} as const

export type ProjectTypeScalarFieldEnum = (typeof ProjectTypeScalarFieldEnum)[keyof typeof ProjectTypeScalarFieldEnum]


export const CrewMembershipScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  isLead: 'isLead',
  joinedAt: 'joinedAt',
  userId: 'userId',
  crewId: 'crewId'
} as const

export type CrewMembershipScalarFieldEnum = (typeof CrewMembershipScalarFieldEnum)[keyof typeof CrewMembershipScalarFieldEnum]


export const TicketAssignmentScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  assignmentType: 'assignmentType',
  assignmentStatus: 'assignmentStatus',
  isActive: 'isActive',
  assignedAt: 'assignedAt',
  claimedAt: 'claimedAt',
  ticketId: 'ticketId',
  crewId: 'crewId',
  assignedById: 'assignedById'
} as const

export type TicketAssignmentScalarFieldEnum = (typeof TicketAssignmentScalarFieldEnum)[keyof typeof TicketAssignmentScalarFieldEnum]


export const TicketAssigneeScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  role: 'role',
  canEdit: 'canEdit',
  joinedAt: 'joinedAt',
  leftAt: 'leftAt',
  userId: 'userId',
  assignmentId: 'assignmentId'
} as const

export type TicketAssigneeScalarFieldEnum = (typeof TicketAssigneeScalarFieldEnum)[keyof typeof TicketAssigneeScalarFieldEnum]


export const CrewSkillScalarFieldEnum = {
  organizationId: 'organizationId',
  crewId: 'crewId',
  skillId: 'skillId'
} as const

export type CrewSkillScalarFieldEnum = (typeof CrewSkillScalarFieldEnum)[keyof typeof CrewSkillScalarFieldEnum]


export const TicketSkillScalarFieldEnum = {
  organizationId: 'organizationId',
  ticketId: 'ticketId',
  skillId: 'skillId'
} as const

export type TicketSkillScalarFieldEnum = (typeof TicketSkillScalarFieldEnum)[keyof typeof TicketSkillScalarFieldEnum]


export const ProjectAssetScalarFieldEnum = {
  organizationId: 'organizationId',
  projectId: 'projectId',
  assetId: 'assetId'
} as const

export type ProjectAssetScalarFieldEnum = (typeof ProjectAssetScalarFieldEnum)[keyof typeof ProjectAssetScalarFieldEnum]


export const ProjectPremiseScalarFieldEnum = {
  organizationId: 'organizationId',
  projectId: 'projectId',
  premiseId: 'premiseId'
} as const

export type ProjectPremiseScalarFieldEnum = (typeof ProjectPremiseScalarFieldEnum)[keyof typeof ProjectPremiseScalarFieldEnum]


export const ProjectTypeLayersScalarFieldEnum = {
  organizationId: 'organizationId',
  projectTypeId: 'projectTypeId',
  layerId: 'layerId'
} as const

export type ProjectTypeLayersScalarFieldEnum = (typeof ProjectTypeLayersScalarFieldEnum)[keyof typeof ProjectTypeLayersScalarFieldEnum]


export const ShiftScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  status: 'status',
  shiftStart: 'shiftStart',
  shiftEnd: 'shiftEnd',
  userId: 'userId'
} as const

export type ShiftScalarFieldEnum = (typeof ShiftScalarFieldEnum)[keyof typeof ShiftScalarFieldEnum]


export const SkillScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  name: 'name',
  description: 'description'
} as const

export type SkillScalarFieldEnum = (typeof SkillScalarFieldEnum)[keyof typeof SkillScalarFieldEnum]


export const TicketScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  ticketNumber: 'ticketNumber',
  priority: 'priority',
  status: 'status',
  description: 'description',
  customFieldValues: 'customFieldValues',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  state: 'state',
  country: 'country',
  zipcode: 'zipcode',
  latitude: 'latitude',
  longitude: 'longitude',
  startDate: 'startDate',
  endDate: 'endDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  adminReviewNotes: 'adminReviewNotes',
  adminReviewedAt: 'adminReviewedAt',
  adminReviewedById: 'adminReviewedById',
  projectId: 'projectId',
  createdById: 'createdById',
  assetId: 'assetId',
  premiseId: 'premiseId'
} as const

export type TicketScalarFieldEnum = (typeof TicketScalarFieldEnum)[keyof typeof TicketScalarFieldEnum]


export const AiReviewScalarFieldEnum = {
  organizationId: 'organizationId',
  summary: 'summary',
  issueIdentified: 'issueIdentified',
  severityAssessment: 'severityAssessment',
  recommendedAction: 'recommendedAction',
  dataCompletenessScore: 'dataCompletenessScore',
  potentialDiscrepancies: 'potentialDiscrepancies',
  confidenceScore: 'confidenceScore',
  imageDescriptions: 'imageDescriptions',
  processingStatus: 'processingStatus',
  processingErrors: 'processingErrors',
  reviewedAt: 'reviewedAt',
  aiModelUsed: 'aiModelUsed',
  aiReviewVersion: 'aiReviewVersion',
  ticketId: 'ticketId'
} as const

export type AiReviewScalarFieldEnum = (typeof AiReviewScalarFieldEnum)[keyof typeof AiReviewScalarFieldEnum]


export const TicketNoteScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  title: 'title',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ticketId: 'ticketId',
  createdById: 'createdById'
} as const

export type TicketNoteScalarFieldEnum = (typeof TicketNoteScalarFieldEnum)[keyof typeof TicketNoteScalarFieldEnum]


export const TicketUploadScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  s3Key: 's3Key',
  filename: 'filename',
  mimetype: 'mimetype',
  size: 'size',
  uploadedAt: 'uploadedAt',
  ticketId: 'ticketId',
  uploadedById: 'uploadedById'
} as const

export type TicketUploadScalarFieldEnum = (typeof TicketUploadScalarFieldEnum)[keyof typeof TicketUploadScalarFieldEnum]


export const UserScalarFieldEnum = {
  organizationId: 'organizationId',
  id: 'id',
  name: 'name',
  email: 'email',
  password: 'password',
  role: 'role',
  isOnline: 'isOnline',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]

